import { UUIDRegex } from '@cbgms/base/utils/uuid'

export const isValidUUID = (value?: string): string | void =>
  value && !RegExp(UUIDRegex, 'i').test(value) ? 'global.not_a_valid_uuid' : undefined
